import React from 'react';
import { Typography, Divider, Grid, Button, Link } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useNavigate } from 'react-router';
import { addSpacesToCamelCase } from 'utils/commonUtil';
import { gridSpacing } from 'store/constant';

export default function OrganizationCard({ machineDetails, RecyclerToggleBoughtRentedAssignedCondition }) {
  const navigate = useNavigate();

  return (
    <Grid container spacing={gridSpacing} style={{ paddingTop: '15px' }}>
      {/* Buyer Organization Card */}
      <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '100%' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              {(machineDetails?.buyer?.id?.trim() || '') === (machineDetails?.client?.id?.trim() || '')
                ? 'Buyer & Client Organization'
                : 'Buyer Organization'}
            </Typography>
          </div>
          {machineDetails?.buyer !== null ? (
            <>
              <div className="organization_machine_name">
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  {machineDetails?.buyer?.name || 'N.A.'}
                </Typography>
                <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                  {machineDetails?.buyer?.website}
                </Typography>
                <Divider />
                <Typography variant="h4" component="p" className="point_cntct_hd">
                  Point Of Contact{' '}
                </Typography>
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Email :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.buyer?.mainPOC?.email ? (
                            <Link
                              href={`mailto:${machineDetails?.buyer?.mainPOC?.email}`}
                              sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                              // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                            >
                              {machineDetails?.buyer?.mainPOC?.email}
                            </Link>
                          ) : (
                            'N.A.'
                          )}
                        </Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Phone :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.buyer?.mainPOC?.phone || 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit', paddingTop: '15px' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Organization Type :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.buyerOrgType
                            ? Array.isArray(machineDetails?.buyerOrgType) && machineDetails?.buyerOrgType?.length
                              ? machineDetails?.buyerOrgType.join(', ')
                              : addSpacesToCamelCase(machineDetails?.buyerOrgType)
                            : 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            <>
              <div style={{ padding: '10px 15px 15px' }}>
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  Not Assigned
                </Typography>
              </div>
            </>
          )}
        </div>
      </Grid>
      {/* Seller Organization Card */}
      <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '100%' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              Seller Organization
            </Typography>
          </div>
          {machineDetails?.seller !== null ? (
            <>
              <div className="organization_machine_name">
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  {machineDetails?.seller?.name || 'N.A.'}
                </Typography>
                <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                  {machineDetails?.seller?.website}
                </Typography>
                <Divider />
                <Typography variant="h4" component="p" className="point_cntct_hd">
                  Point Of Contact{' '}
                </Typography>
                {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {machineDetails?.seller?.name}
                          </Typography> */}
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Email :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.seller?.mainPOC?.email ? (
                            <Link
                              href={`mailto:${machineDetails?.seller?.mainPOC?.email}`}
                              sx={{
                                textDecoration: 'underline',
                                color: 'blue',
                                wordBreak: 'break-word'
                              }}
                              // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                            >
                              {machineDetails?.seller?.mainPOC?.email}
                            </Link>
                          ) : (
                            'N.A.'
                          )}
                        </Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Phone :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.seller?.mainPOC?.phone || 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Divider />
                {/* <Typography variant="h4" component="p" style={{ fontWeight: 'bold', paddingTop: 15 }}>
                                Organization Types{' '}
                              </Typography> */}
                <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                  <Grid item xs={12} sx={{ padding: 0 }}>
                    <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                      <div className="" style={{ display: 'inherit', paddingTop: '15px' }}>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                          Organization Type :{' '}
                        </Typography>
                        <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                          {machineDetails?.sellerOrgType
                            ? Array.isArray(machineDetails?.sellerOrgType) && machineDetails?.sellerOrgType?.length
                              ? machineDetails?.sellerOrgType.join(', ')
                              : addSpacesToCamelCase(machineDetails?.sellerOrgType)
                            : 'N.A.'}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            <>
              <div style={{ padding: '10px 15px 15px' }}>
                <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                  Not Assigned
                </Typography>
              </div>
            </>
          )}
        </div>
      </Grid>
      {/* Client Organization Card  */}
      {!RecyclerToggleBoughtRentedAssignedCondition && (
        <>
          {(machineDetails?.buyer?.id?.trim() || '') !== (machineDetails?.client?.id?.trim() || '') && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
                <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '100%' }}>
                  <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                    <Typography
                      component="h4"
                      variant="h3"
                      // sx={{ mr: 1, pb: 1.8 }}
                      sx={{ color: '#fff' }}
                    >
                      Client Organization
                    </Typography>
                  </div>
                  {machineDetails?.client !== null ? (
                    <>
                      <div className="organization_machine_name">
                        <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                          {machineDetails?.client?.name || 'N.A.'}
                        </Typography>
                        <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                          {machineDetails?.client?.website}
                        </Typography>
                        <Divider />
                        <Typography variant="h4" component="p" className="point_cntct_hd">
                          Point Of Contact{' '}
                        </Typography>
                        {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                                {machineDetails?.client?.name}
                              </Typography> */}
                        <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                          <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                            <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                              <div style={{ display: 'inherit' }}>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                  Email :{' '}
                                </Typography>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                  {machineDetails?.client?.mainPOC?.email ? (
                                    <Link
                                      href={`mailto:${machineDetails?.client?.mainPOC?.email}`}
                                      sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                                      // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                    >
                                      {machineDetails?.client?.mainPOC?.email}
                                    </Link>
                                  ) : (
                                    'N.A.'
                                  )}
                                </Typography>
                              </div>
                            </div>
                          </Grid>

                          <Grid item xs={12} sx={{ padding: 0 }}>
                            <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                              <div className="" style={{ display: 'inherit' }}>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                  Phone :{' '}
                                </Typography>
                                <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                  {machineDetails?.client?.mainPOC?.phone || 'N.A.'}
                                </Typography>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ padding: '10px 15px 15px' }}>
                        <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                          Not Assigned
                        </Typography>
                      </div>
                    </>
                  )}
                </div>
              </Grid>
            </>
          )}

          {/* Recycler Organization Card */}
          <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
            <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '100%' }}>
              <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                <Typography
                  component="h4"
                  variant="h3"
                  // sx={{ mr: 1, pb: 1.8 }}
                  sx={{ color: '#fff' }}
                >
                  Recycler Organization
                </Typography>
              </div>
              {machineDetails?.recycler !== null ? (
                <>
                  <div className="organization_machine_name">
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      {machineDetails?.recycler?.name || 'N.A.'}
                    </Typography>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                      {machineDetails?.recycler?.website}
                    </Typography>
                    <Divider />
                    <Typography variant="h4" component="p" className="point_cntct_hd">
                      Point Of Contact{' '}
                    </Typography>
                    {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                                {machineDetails?.recycler?.name}
                              </Typography> */}
                    <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                      <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Email :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.recycler?.mainPOC?.email ? (
                                <Link
                                  href={`mailto:${machineDetails?.recycler?.mainPOC?.email}`}
                                  sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                                  // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                >
                                  {machineDetails?.recycler?.mainPOC?.email}
                                </Link>
                              ) : (
                                'N.A.'
                              )}
                            </Typography>
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} sx={{ padding: 0 }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div className="" style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Phone :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.recycler?.mainPOC?.phone || 'N.A.'}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/Recycler', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'modify',
                                orgObj: machineDetails?.recycler || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(132,194,223)' }}
                        >
                          <EditIcon />
                          &nbsp; Modify Recycler
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ padding: '10px 15px 15px' }}>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      Not Assigned
                    </Typography>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/Recycler', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'assign',
                                orgObj: machineDetails?.recycler || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(56,135,208)' }}
                        >
                          <PersonAddAltIcon />
                          &nbsp; Assign Recycler
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid>

          {/* Service Provider Organization Card  */}
          <Grid item xs={12} sm={12} md={6} lg={4} className="machineModalView">
            <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '100%' }}>
              <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                <Typography
                  component="h4"
                  variant="h3"
                  // sx={{ mr: 1, pb: 1.8 }}
                  sx={{ color: '#fff' }}
                >
                  Service Provider Organization
                </Typography>
              </div>
              {machineDetails?.serviceProvider !== null ? (
                <>
                  <div className="organization_machine_name">
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      {machineDetails?.serviceProvider?.name || 'N.A.'}
                    </Typography>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                      {machineDetails?.serviceProvider?.website}
                    </Typography>
                    <Divider />
                    <Typography variant="h4" component="p" className="point_cntct_hd">
                      Point Of Contact{' '}
                    </Typography>
                    {/* <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                                {machineDetails?.serviceProvider?.name}
                              </Typography> */}
                    <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                      <Grid item xs={12} sx={{ paddingBottom: '5px' }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Email :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.serviceProvider?.mainPOC?.email ? (
                                <Link
                                  href={`mailto:${machineDetails?.serviceProvider?.mainPOC?.email}`}
                                  sx={{ textDecoration: 'underline', color: 'blue', wordBreak: 'break-word' }}
                                  // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                >
                                  {machineDetails?.serviceProvider?.mainPOC?.email}
                                </Link>
                              ) : (
                                'N.A.'
                              )}
                            </Typography>
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} sx={{ padding: 0 }}>
                        <div style={{ border: '1px solid #fff', borderRadius: '6px' }}>
                          <div className="" style={{ display: 'inherit' }}>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                              Phone :{' '}
                            </Typography>
                            <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                              {machineDetails?.serviceProvider?.mainPOC?.phone || 'N.A.'}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/ServiceProvider', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'modify',
                                orgObj: machineDetails?.serviceProvider || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(132,194,223)' }}
                        >
                          <EditIcon />
                          &nbsp; Modify Service Provider
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ padding: '10px 15px 15px' }}>
                    <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                      Not Assigned
                    </Typography>
                    <div style={{ paddingTop: '10px', borderColor: '#fff' }}>
                      <div className="machineViewBtnWrap" style={{ paddingLeft: 0 }}>
                        <Button
                          disableElevation
                          size="large"
                          type="button"
                          variant="contained"
                          color="warning"
                          onClick={() => {
                            navigate('/dashboard/machines/add/assign-organization/ServiceProvider', {
                              state: {
                                machineObj: machineDetails || null,
                                type: 'assign',
                                orgObj: machineDetails?.serviceProvider || null
                              }
                            });
                          }}
                          className="machineViewBtn"
                          // style={{ backgroundColor: '#F8BA40' }} // Adjust button padding and font size
                          style={{ backgroundColor: 'rgb(86,135,208)' }}
                        >
                          <PersonAddAltIcon />
                          &nbsp; Assign Service Provider
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid>
        </>
      )}
      {/* Rental Organization - Off */}
      {/* {machineDetails &&
                      loginUser &&
                      orgType &&
                      machineDetails?.buyerOrgType === 'Recycler' &&
                      machineDetails?.client?.id === loginUser?.organization?.id &&
                      orgType === 'Enterprise' && (
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div style={{ border: '1px solid #6fd74b', borderRadius: '6px', height: '100%' }}>
                            <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                              <Typography
                                component="h4"
                                variant="h3"
                                // sx={{ mr: 1, pb: 1.8 }}
                                sx={{ color: '#fff' }}
                              >
                                Rental Organization
                              </Typography>
                            </div>
                            {machineDetails?.buyer !== null ? (
                              <>
                                <div style={{ padding: '10px 15px 15px' }}>
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                                    {machineDetails?.buyer?.name || 'N.A.'}
                                  </Typography>
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'unset', paddingTop: 10, paddingBottom: '10px' }}>
                                    {machineDetails?.buyer?.website}
                                  </Typography>
                                  <Divider />
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'bold', paddingTop: 15 }}>
                                    Point Of Contact{' '}
                                  </Typography>
                                  <Grid container spacing={2} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                                    <Grid item xs={12} sx={{ padding: 0 }}>
                                      <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
                                        <div className="address_locationmain" style={{ margin: '2px', padding: '5px', display: 'inherit' }}>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                            Email :{' '}
                                          </Typography>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                            {machineDetails?.buyer?.mainPOC?.email ? (
                                              <Link
                                                href={`mailto:${machineDetails?.buyer?.mainPOC?.email}`}
                                                sx={{ textDecoration: 'underline', color: 'blue' }}
                                                // style={{ textDecoration: 'underline', textDecorationColor: 'blue', color: 'inherit' }}
                                              >
                                                {machineDetails?.buyer?.mainPOC?.email}
                                              </Link>
                                            ) : (
                                              'N.A.'
                                            )}
                                          </Typography>
                                        </div>
                                      </div>
                                    </Grid>
    
                                    <Grid item xs={12} sx={{ padding: 0 }}>
                                      <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
                                        <div className="address_locationmain" style={{ margin: '2px', padding: '5px', display: 'inherit' }}>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                                            Phone :{' '}
                                          </Typography>
                                          <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 2 }}>
                                            {machineDetails?.buyer?.mainPOC?.phone || 'N.A.'}
                                          </Typography>
                                        </div>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </>
                            ) : (
                              <>
                                <div style={{ padding: '10px 15px 15px' }}>
                                  <Typography variant="h4" component="p" style={{ fontWeight: 'bold' }}>
                                    Not Assigned
                                  </Typography>
                                </div>
                              </>
                            )}
                          </div>
                        </Grid>
                      )} */}
    </Grid>
  );
}
